export enum EstadosUsuario {
    incompleto = 0,
    pendienteValidacion = 1,
    validado = 2
}
